import React from 'react';
import './HomeChargers.scss';
import { FormattedMessage } from 'react-intl';

const HomeChargers = () => {
  return (
    <div className="page-home-chargers">
      <h1 className="title-home-chargers">
        <FormattedMessage
          id="homeChargers.title"
          defaultMessage="Select a charger that meets your needs"
          description="Select a charger that meets your needs"
        />
      </h1>
      <h2 className="subtitle-home-chargers">
        <FormattedMessage
          id="homeChargers.subtitle"
          defaultMessage="Browse chargers to find the perfect fit for your EV and charging needs."
          description="Browse chargers to find the perfect fit for your EV and charging needs."
        />
      </h2>
      <zr-chargers-catalog-widget></zr-chargers-catalog-widget>
    </div>
  );
};

export default HomeChargers;
